/* eslint-env browser */
import React, { Children, Component } from 'react';
import { isObject, isEmpty } from 'lodash';
import { getEntries } from 'Client/session-storage-api/sessionStorageApi';

import { ABTestContext } from './ABTestContext';

const isValidValues = (src, values) => {
  return (
    isObject(values) &&
    !isEmpty(values) &&
    !Object.entries(values).every(([key, value]) => src[key] === value)
  );
};
const ABTEST_PREFIX = 'testAB.';
const ABTEST_EVENT = 'testAB';

const fetchABTestData = () => {
  return getEntries()
    .filter(([key]) => key.startsWith(ABTEST_PREFIX))
    .reduce(
      (acc, [key, value]) => ({ ...acc, [key.replace(ABTEST_PREFIX, '')]: value.toString() }),
      {},
    );
};

export default class ABTestProvider extends Component {
  state = {
    ...fetchABTestData(),
  };

  componentDidMount() {
    document.addEventListener(ABTEST_EVENT, this.handleEvent, false);
  }

  componentWillUnmount() {
    document.removeEventListener(ABTEST_EVENT, this.handleEvent, false);
  }

  handleEvent = e => {
    /**
     * TODO
     * When REACT 16 ready
     * this.setState((prevState) => isValidValues(prevState, e.values) ? { ...e.values } : null);
     */
    if (isValidValues(this.state, e.values)) {
      this.setState(() => ({ ...e.values }));
    }
  };

  render() {
    const { children } = this.props;

    return (
      <ABTestContext.Provider value={this.state}>
        {children ? Children.only(children) : null}
      </ABTestContext.Provider>
    );
  }
}
